import { post } from "../hooks/useHttp";

export const getFavMasjids = (page: number) => {
    return post(`/get-fav-masjids?page=${page}` , {});
  };